import { IAppState } from '../../../common/state';
import { ERegionalDistrictsStatus } from '../../../types/regionalDistricts';

export const selectRegionalDistrictsStatus = (state: IAppState): ERegionalDistrictsStatus => {
  return state.filters.regionalDistrictsModal.status;
};
